/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Listen_Go_CookingInputs */

const en_onboarding_listen_go_cooking = /** @type {(inputs: Onboarding_Listen_Go_CookingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cooking or meal prepping`)
};

const es_onboarding_listen_go_cooking = /** @type {(inputs: Onboarding_Listen_Go_CookingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cocinando o preparando comida`)
};

/**
* | output |
* | --- |
* | "Cooking or meal prepping" |
*
* @param {Onboarding_Listen_Go_CookingInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const onboarding_listen_go_cooking = /** @type {((inputs?: Onboarding_Listen_Go_CookingInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Listen_Go_CookingInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_onboarding_listen_go_cooking(inputs)
	return en_onboarding_listen_go_cooking(inputs)
});